import { ReactNode } from 'react';

import { Button, Result } from 'antd';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';

interface AntdProviderProps {
  children: ReactNode;
}

const ErrorBoundary = ({ children }: AntdProviderProps) => {
  return (
    <ReactErrorBoundary
      fallback={
        <Result
          status="500"
          title="Кажется что-то сломалось"
          subTitle="Попробуйте перезапустить приложение или обратитесь к системному администратору"
          extra={
            <Button type="primary" onClick={() => window.location.reload()}>
              Перезапустить
            </Button>
          }
        />
      }
    >
      {children}
    </ReactErrorBoundary>
  );
};

export default ErrorBoundary;
